export function detectOfflinePosPlatform() {
  return (
    navigator.userAgentData?.platform
    || navigator.platform
    || "Unknown platform"
  ).slice(0, 80);
}

export function defaultOfflinePosDeviceName() {
  const platform = detectOfflinePosPlatform();
  const browser = navigator.userAgentData?.brands?.[0]?.brand || "Browser";
  return `${browser} on ${platform}`.slice(0, 120);
}

export function offlinePosUserAgent() {
  return String(navigator.userAgent || "").slice(0, 500) || null;
}
